export default __webpack_public_path__ + "static/media/mjolnir.61f31e18.png";